import React from 'react';
import './MasterclassBox.scss';
import { useTranslation } from 'react-i18next';
import { useAccount } from '../../../contexts/account/AccountContexts';
import { openMasterclassWithSso } from '../../../services/masterclass/MasterclassSsoService';

const MasterclassBox: React.FC = () => {
  const { t } = useTranslation();
  const { accountResponse } = useAccount();

  return (
    <div className="masterclass-box">
      <div className="masterclass-box__header">
        <span className="masterclass-box__eyebrow">{t('masterclass.eyebrow')}</span>
      </div>
      <h3 className="masterclass-box__title">
        {t('masterclass.titleLine1')}
        <span>{t('masterclass.titleLine2')}</span>
      </h3>
      <p className="masterclass-box__desc">{t('masterclass.description')}</p>
      <button type="button" className="masterclass-box__cta" onClick={() => openMasterclassWithSso(accountResponse)}>
        {t('masterclass.cta')}
      </button>
    </div>
  );
};

export default MasterclassBox;
